module.exports = __webpack_public_path__ + "static/media/50pic.e7b4437a.jpg";